import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import UrlHandlerService from '../services/UrlHandlerService';

interface UsePaymentHandlerProps {
  fetchTotals: () => Promise<void>;
  setIsOverlayOpen: (isOpen: boolean) => void;
}

const usePaymentHandler = ({ fetchTotals, setIsOverlayOpen }: UsePaymentHandlerProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    const urlHandler = UrlHandlerService.getInstance();
    
    const handlePaymentConfirmation = async (url: URL) => {
      const id = url.searchParams.get("id");
      const token = url.searchParams.get("token");
      
      if (id === 'stripe' && token) {
        await fetchTotals();
        setIsOverlayOpen(false);
      }
    };

    urlHandler.registerHandler('payment-stripe', handlePaymentConfirmation);

    return () => {
      urlHandler.removeHandler('payment-stripe');
    };
  }, [navigate, fetchTotals, setIsOverlayOpen]);
};

export default usePaymentHandler;
